module.exports = __webpack_public_path__ + "img/logo-white.53c8fd15.svg";